import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Form, Modal } from "reactstrap";
import { isParsable, parseJsonRecursively, xmlToJSON, formatXmlData } from "../../../../helperFunctions";

const PayinReqResLogsModal = ({ isViewsendDataModal, onCloseModal, data }) => {
  const [parsedData1, setParsedData1] = useState(null);
  const [parsedData3, setParsedData3] = useState(null);

  useEffect(() => {
    let parsedRequestBody = null;
    try {
      parsedRequestBody = isParsable(data?.requestBody)
        ? parseJsonRecursively(JSON.parse?.(data?.requestBody))
        : data?.requestBody;

      if (
        typeof parsedRequestBody === "string" &&
        (parsedRequestBody.trim().startsWith("<?xml") ||
          parsedRequestBody.trim().startsWith("<"))
      ) {
        const xmlParsed = xmlToJSON(parsedRequestBody);
        if (xmlParsed && typeof xmlParsed === "object") {
          parsedRequestBody = formatXmlData(parseJsonRecursively(xmlParsed));
        }
      }
    } catch (error) {
      console.error("Error parsing requestBody:", error);
    }
    setParsedData1(parsedRequestBody);

    try {
      let parsedResponseBody = isParsable(data?.responseBody)
        ? parseJsonRecursively(JSON.parse(data?.responseBody))
        : data?.responseBody;

      if (
        typeof parsedResponseBody === "string" &&
        (parsedResponseBody.trim().startsWith("<?xml") ||
          parsedResponseBody.trim().startsWith("<"))
      ) {
        const xmlParsed = xmlToJSON(parsedResponseBody);
        if (xmlParsed && typeof xmlParsed === "object") {
          parsedResponseBody = formatXmlData(parseJsonRecursively(xmlParsed));
        }
      }

      setParsedData3(parsedResponseBody);
    } catch (error) {
      console.error("Error parsing responseBody:", error);
    }
  }, [data]);
  return (
    <Form>
      <Modal
        isOpen={!!isViewsendDataModal}
        toggle={() => onCloseModal()}
        className="modal-xl"
        centered={true}
      >
        <div className="modal-header">
          <h3 className="modal-title mt-0">Payin Req Res Logs</h3>
          <i
            onClick={() => {
              onCloseModal();
            }}
            className="fa-solid fa-xmark"
          ></i>
        </div>
        <div className="modal-body w-100">
          <div className="row">
            <div className="col-lg-6">
              <Card>
                <CardBody>
                  <h5>URL</h5>
                  <p>
                    <span className="badge badge-success">
                      {data?.requestMethod}
                    </span>
                    : {data?.requestUrl}
                  </p>
                  <h5>Request Body</h5>
                  <div className="webevent-sec mb-1 req_text_wrap requestContainer">
                    <pre>{parsedData1 ? JSON.stringify(parsedData1, null, 2) : "No request body"}</pre>
                  </div>
                </CardBody>
              </Card>
            </div>
            <div className="col-lg-6">
              <Card>
                <CardBody>
                  <h5>Status Code </h5>
                  <p className="badge badge-success">
                    {data?.responseHttpCode}
                  </p>
                  <h5>Response Body</h5>
                  <div className="webevent-sec mb-1 req_text_wrap requestContainer">
                    <pre>{parsedData3 ? JSON.stringify(parsedData3, null, 2) : "No response body"}</pre>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <div className="d-flex justify-content-end button-space">
            <Button className="graybutton" onClick={() => onCloseModal()}>
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
    </Form>
  );
};

export default PayinReqResLogsModal;
